/**
 * Main JavaScript entry point for Maybourne Claridge's theme
 * Initializes all components and sets up event listeners
 */

import ee from './ee'
// Import manager for side effects only
import componentManager from './managers'
// Import Maybourne components
// tag-filters component removed - now using native Shopify 2.0 filters

// CSS is already handled through postcss process

import './managers.js'

/**
 * Initialize the application
 * @returns {boolean} - Whether initialization was successful
 */
function initializeApp() {
  try {
    // Initialize components through the event emitter
    ee.emit('initComponents')

    // Add any global event listeners or initialization here
    document.documentElement.classList.add('js-loaded')

    return true
  } catch (error) {
    console.error('Failed to initialize application:', error)
    return false
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp)
} else {
  initializeApp()
}

// Make app accessible globally for debugging and integration with Shopify
window.maybourneApp = {
  ee,
  componentManager,
  // Add additional objects or methods that should be accessible globally

  /**
   * Manually initialize a specific component area after dynamic content is loaded
   * @param {string} containerSelector - CSS selector for the container with dynamic content
   */
  refreshComponents(containerSelector = 'body') {
    console.log(`Refreshing components in: ${containerSelector}`)
    ee.emit('initComponents', containerSelector)
  },
}
